import { render, staticRenderFns } from "./WhiteBoard.vue?vue&type=template&id=3a865d7e&scoped=true"
import script from "./WhiteBoard.vue?vue&type=script&lang=js"
export * from "./WhiteBoard.vue?vue&type=script&lang=js"
import style1 from "./WhiteBoard.vue?vue&type=style&index=1&id=3a865d7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a865d7e",
  null
  
)

export default component.exports